export default {
  styleOverrides: {
    root: {
      gap: "15px",
      padding: "0px 10px",
      ".MuiToggleButtonGroup-grouped:not(:first-of-type)": {
        borderLeft: "0px",
        margin: "0px",
      },
    },
  },
};
